window.shares = function (types, pt_img, url) {
    if(!pt_img) pt_img = '';
    if(url === "" || url === undefined || url === 'undefined'){
        url = location.href;
    }
    switch(types){
        case "fb":
            window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(url)) );
            break;
        case "tr":
            window.open('https://twitter.com/intent/tweet?original_referer='+encodeURIComponent(url)+'&url='+encodeURIComponent(url));
            // window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(document.title)) .concat('') .concat(encodeURIComponent(url)))
            break;
        case "gp":
            window.open('http://plus.google.com/share?url='.concat(encodeURIComponent(url)) )
            break;
        case "sn":
            window.open('http://v.t.sina.com.cn/share/share.php?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(document.title));
            break;
        case "pt":
            window.open('http://pinterest.com/pin/create/like/?url=' + encodeURIComponent(url) +'&media='+encodeURIComponent(pt_img) + '&description=' + encodeURIComponent(document.title));
            break;
        case "line":
            //http://line.naver.jp/R/msg/text/?{msg}
            //msg = 在LINE裡面顯示的內容
            //僅限行動裝置
            window.open('https://social-plugins.line.me/lineit/share?url='+encodeURIComponent(url));
            break;
    }
    return false;
} // end of function

window.gotoURL = function (url, type) {
    if(type === "open"){
        window.open(url);
    }else{
        window.location.href = url;
    }
} // end of function

// 鎖捲軸
// 例: 如果要鎖 body:
// var body = $('body');
// lockScroll(body);
window.lockScroll = function (target) {
    let scroll_top = $(window).scrollTop();
    let lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        $(target).data('lock_count', 1);

        target.data('scroll_style', target.attr('style'));
        target.data('scroll_top'  , scroll_top);
        target.css({"overflow":"hidden", "position":"fixed", "top": (scroll_top * -1)+"px"});
    } else {
        $(target).data('lock_count', lock_count + 1);
    } // end of if
} // end of function

// 開捲軸 - 如果鎖了3次, 需要呼叫此　function 3 次後才會解鎖
//
// target　要解開鎖的目標
// unlock_all 強制解鎖, 無視鎖被加了幾次
window.unlockScroll = function (target, unlock_all) {
    var lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        lock_count = 0;
        $(target).data('lock_count', 0);
    } else {
        lock_count = lock_count - 1;
        $(target).data('lock_count', lock_count);
    } // end of if

    if (lock_count === 0 || (typeof unlock_all !== 'undefined' && unlock_all === true)) {
        var scroll_top   = target.data('scroll_top'  );
        var scroll_style = target.data('scroll_style');

        if (scroll_style) {
            target.attr('style', scroll_style);
        } else {
            target.removeAttr('style');
        }

        $(window).scrollTop(scroll_top);
    } // end of if
} // end of function

/**
 /* 動態下拉選單
 /* route       資料來源
 /* data        參數
 /* target_dom  目標的dom 通常是select dom (如有選中的值放在 data-selected)
 /* target_tmpl 樣板
 /* callback    長出選單後要做的事情 通常是兩層式選單的話就在呼叫自己一次 如下範例
 /* example:
 /*   dynamicBuildSelector('{{route('backend_ajax_get_product_category')}}',
 /*                                  'level=1',
 /*                                  $("select[name='parent_product_category_id']"),
 /*                                  $('#tmpl-option-product_category'),
 /*                                  function (select) {
/*                                      select.on('change', function() {
/*                                          dynamicBuildSelector('{{route('backend_ajax_get_product_category')}}',
 /*                                                        'level=2&parent_id='+$(this).val(),
 /*                                                        $("select[name='product_category_id']"),
 /*                                                        $('#tmpl-option-product_category'));
 /*                                      });
 /*                                      {{-- 直接執行一次讓第二層選中的值selected --}}
 /*                                      select.change();
 /*
 /*                                  });
 */
window.dynamicBuildSelector = function (route, data, target_dom, target_tmpl, callback) {
    $.ajax({
        type: "POST",
        url: route,
        data: data,
        dataType: "json",
        cache: false,
        success: function (response) {

            let template   = $.templates(target_tmpl);
            let tmpl       = template.render(response);
            let selected   = target_dom.data('selected');

            target_dom.empty();
            target_dom.append(tmpl);

            target_dom.prepend( "<option value=''>請選擇</option>" );
            target_dom.val(selected);
            target_dom.data('selected','');
            if(callback){
                callback(target_dom);
            }

        }, error: function (e) {
            confirmDialog('出現錯誤，請稍後再試','','','','','error');
        }
    });
}
